import { apiCall } from './gqlClient';

const GETALLUSERWORKOUTPLANS_QUERY = `
  query getAllUserWorkoutPlans($userId: Int!) {
    getAllUserWorkoutPlans(userId: $userId)
    {
      id
			providerId
			userId
			groupId
			title
			description
			price
			public
			numberOfWeeks
			currentPlanNumberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			personalPlan
			thumbnailUrl
			enrolled
			archive
      ...fragments
    }
  }`;

export const getAllUserWorkoutPlansApiCall = async ({userId}, fragments = null) => apiCall({ query: GETALLUSERWORKOUTPLANS_QUERY, variables: {userId}, fragments });

const GETPROVIDERUSERSWORKOUTPLANS_QUERY = `
  query getProviderUsersWorkoutPlans {
    getProviderUsersWorkoutPlans
    {
      id
			startTime
			endTime
			numberOfWeeks
			price
			active
			userId
			planId
			planTitle
      ...fragments
    }
  }`;

export const getProviderUsersWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERUSERSWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETMYGROUPEDWORKOUTPLANS_QUERY = `
  query getMyGroupedWorkoutPlans {
    getMyGroupedWorkoutPlans
    {
      id
			userWorkoutPlanId
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			thumbnailUrl
      ...fragments
    }
  }`;

export const getMyGroupedWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETMYGROUPEDWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETALLMYWORKOUTS_QUERY = `
  query getAllMyWorkouts {
    getAllMyWorkouts
    {
      id
			providerId
			title
			description
			level
			dateCreated
			imageId
			thumbnailUrl
			price
			active
			personalPlan
      ...fragments
    }
  }`;

export const getAllMyWorkoutsApiCall = async (fragments = null) => apiCall({ query: GETALLMYWORKOUTS_QUERY, variables: {}, fragments });

const GETALLMYASSIGNEDWORKOUTPLANS_QUERY = `
  query getAllMyAssignedWorkoutPlans {
    getAllMyAssignedWorkoutPlans
    {
      id
			userWorkoutPlanId
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			thumbnailUrl
      ...fragments
    }
  }`;

export const getAllMyAssignedWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETALLMYASSIGNEDWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETMYWORKOUTPLANS_QUERY = `
  query getMyWorkoutPlans {
    getMyWorkoutPlans
    {
      id
			userWorkoutPlanId
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			thumbnailUrl
      ...fragments
    }
  }`;

export const getMyWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETMYWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETUSERWORKOUTPLANDETAILS_QUERY = `
  query getUserWorkoutPlanDetails($workoutPlanId: String!, $userId: Int, $groupId: Int) {
    getUserWorkoutPlanDetails(workoutPlanId: $workoutPlanId, userId: $userId, groupId: $groupId)
    {
      id
			providerId
			userId
			groupId
			title
			description
			price
			public
			numberOfWeeks
			currentPlanNumberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			personalPlan
			thumbnailUrl
			enrolled
			archive
      ...fragments
    }
  }`;

export const getUserWorkoutPlanDetailsApiCall = async ({workoutPlanId, userId, groupId}, fragments = null) => apiCall({ query: GETUSERWORKOUTPLANDETAILS_QUERY, variables: {workoutPlanId, userId, groupId}, fragments });

const GETMYWORKOUTPLANDETAILS_QUERY = `
  query getMyWorkoutPlanDetails($workoutPlanId: String!, $groupId: Int) {
    getMyWorkoutPlanDetails(workoutPlanId: $workoutPlanId, groupId: $groupId)
    {
      id
			providerId
			userId
			groupId
			title
			description
			price
			public
			numberOfWeeks
			currentPlanNumberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			personalPlan
			thumbnailUrl
			enrolled
			archive
      ...fragments
    }
  }`;

export const getMyWorkoutPlanDetailsApiCall = async ({workoutPlanId, groupId}, fragments = null) => apiCall({ query: GETMYWORKOUTPLANDETAILS_QUERY, variables: {workoutPlanId, groupId}, fragments });

const GETUSERWORKOUTDETAILS_QUERY = `
  query getUserWorkoutDetails($id: String!) {
    getUserWorkoutDetails(id: $id)
    {
      id
			providerId
			title
			description
			level
			dateCreated
			imageId
			thumbnailUrl
			price
			active
      ...fragments
    }
  }`;

export const getUserWorkoutDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETUSERWORKOUTDETAILS_QUERY, variables: {id}, fragments });

const GETALLUSERWORKOUTS_QUERY = `
  query getAllUserWorkouts {
    getAllUserWorkouts
    {
      id
			providerId
			title
			description
			level
			dateCreated
			imageId
			thumbnailUrl
			price
			active
			personalPlan
      ...fragments
    }
  }`;

export const getAllUserWorkoutsApiCall = async (fragments = null) => apiCall({ query: GETALLUSERWORKOUTS_QUERY, variables: {}, fragments });

const GETALLNOTASSIGNEDUSERSFORPLAN_QUERY = `
  query getAllNotAssignedUsersForPlan($id: String!) {
    getAllNotAssignedUsersForPlan(id: $id)
  }`;

export const getAllNotAssignedUsersForPlanApiCall = async ({id}, ) => apiCall({ query: GETALLNOTASSIGNEDUSERSFORPLAN_QUERY, variables: {id}});

const GETALLNOTASSIGNEDGROUPSFORPLAN_QUERY = `
  query getAllNotAssignedGroupsForPlan($id: String!) {
    getAllNotAssignedGroupsForPlan(id: $id)
  }`;

export const getAllNotAssignedGroupsForPlanApiCall = async ({id}, ) => apiCall({ query: GETALLNOTASSIGNEDGROUPSFORPLAN_QUERY, variables: {id}});

const GETUSERWORKOUTPLANDATES_QUERY = `
  query getUserWorkoutPlanDates($templatePlanId: String!, $userId: Int!, $ignorePlanId: String) {
    getUserWorkoutPlanDates(templatePlanId: $templatePlanId, userId: $userId, ignorePlanId: $ignorePlanId)
  }`;

export const getUserWorkoutPlanDatesApiCall = async ({templatePlanId, userId, ignorePlanId}, ) => apiCall({ query: GETUSERWORKOUTPLANDATES_QUERY, variables: {templatePlanId, userId, ignorePlanId}});

const CHECKIFPLANSHOULDUPDATEFROMCURRENTCONFIG_QUERY = `
  query checkIfPlanShouldUpdateFromCurrentConfig($userPlanId: String!) {
    checkIfPlanShouldUpdateFromCurrentConfig(userPlanId: $userPlanId)
  }`;

export const checkIfPlanShouldUpdateFromCurrentConfigApiCall = async ({userPlanId}, ) => apiCall({ query: CHECKIFPLANSHOULDUPDATEFROMCURRENTCONFIG_QUERY, variables: {userPlanId}});

const CREATEUSERWORKOUTPLAN_QUERY = `
  mutation createUserWorkoutPlan($request: UserWorkoutPlanInput!) {
    createUserWorkoutPlan(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createUserWorkoutPlanApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEUSERWORKOUTPLAN_QUERY, variables: {request}, fragments });

const UPDATEUSERWORKOUTPLANFROMCURRENTPLANCONFIGURATION_QUERY = `
  mutation updateUserWorkoutPlanFromCurrentPlanConfiguration($userPlanId: String!, $startTime: DateTime!) {
    updateUserWorkoutPlanFromCurrentPlanConfiguration(userPlanId: $userPlanId, startTime: $startTime)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateUserWorkoutPlanFromCurrentPlanConfigurationApiCall = async ({userPlanId, startTime}, fragments = null) => apiCall({ query: UPDATEUSERWORKOUTPLANFROMCURRENTPLANCONFIGURATION_QUERY, variables: {userPlanId, startTime}, fragments });

const CREATEUSERWORKOUTPLANBYGROUP_QUERY = `
  mutation createUserWorkoutPlanByGroup($request: UserWorkoutPlanInput!) {
    createUserWorkoutPlanByGroup(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createUserWorkoutPlanByGroupApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEUSERWORKOUTPLANBYGROUP_QUERY, variables: {request}, fragments });

const ASSIGNFREEUSERWORKOUTPLAN_QUERY = `
  mutation assignFreeUserWorkoutPlan($id: String!) {
    assignFreeUserWorkoutPlan(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const assignFreeUserWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: ASSIGNFREEUSERWORKOUTPLAN_QUERY, variables: {id}, fragments });

const UNASSIGNFREEUSERWORKOUTPLAN_QUERY = `
  mutation unassignFreeUserWorkoutPlan($id: String!) {
    unassignFreeUserWorkoutPlan(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const unassignFreeUserWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: UNASSIGNFREEUSERWORKOUTPLAN_QUERY, variables: {id}, fragments });

const UPDATEUSERWORKOUTPLAN_QUERY = `
  mutation updateUserWorkoutPlan($request: UserWorkoutPlanUpdateInput!) {
    updateUserWorkoutPlan(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateUserWorkoutPlanApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEUSERWORKOUTPLAN_QUERY, variables: {request}, fragments });

const CREATEUSERCIRCUIT_QUERY = `
  mutation createUserCircuit($request: UserCircuitInput!) {
    createUserCircuit(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createUserCircuitApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEUSERCIRCUIT_QUERY, variables: {request}, fragments });

const UPDATEUSERCIRCUIT_QUERY = `
  mutation updateUserCircuit($request: UserCircuitUpdateInput!) {
    updateUserCircuit(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateUserCircuitApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEUSERCIRCUIT_QUERY, variables: {request}, fragments });

const CREATEUSERCIRCUITEQUIPMENT_QUERY = `
  mutation createUserCircuitEquipment($request: UserCircuitEquipmentInput!) {
    createUserCircuitEquipment(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createUserCircuitEquipmentApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEUSERCIRCUITEQUIPMENT_QUERY, variables: {request}, fragments });

const UPDATEUSERCIRCUITEQUIPMENT_QUERY = `
  mutation updateUserCircuitEquipment($request: UserCircuitEquipmentInput!) {
    updateUserCircuitEquipment(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateUserCircuitEquipmentApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEUSERCIRCUITEQUIPMENT_QUERY, variables: {request}, fragments });

const CHANGEUSERWORKOUTPLANSTATUS_QUERY = `
  mutation changeUserWorkoutPlanStatus($id: String!, $active: Boolean!) {
    changeUserWorkoutPlanStatus(id: $id, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeUserWorkoutPlanStatusApiCall = async ({id, active}, fragments = null) => apiCall({ query: CHANGEUSERWORKOUTPLANSTATUS_QUERY, variables: {id, active}, fragments });

const CHANGEUSERWORKOUTSCHEDULE_QUERY = `
  mutation changeUserWorkoutSchedule($request: UserWorkoutScheduleInput!) {
    changeUserWorkoutSchedule(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeUserWorkoutScheduleApiCall = async ({request}, fragments = null) => apiCall({ query: CHANGEUSERWORKOUTSCHEDULE_QUERY, variables: {request}, fragments });

const CHANGEUSERPLANSTARTENDTIME_QUERY = `
  mutation changeUserPlanStartEndTime($id: String!, $startTime: DateTime!, $endTime: DateTime!, $userId: Int, $groupId: Int) {
    changeUserPlanStartEndTime(id: $id, startTime: $startTime, endTime: $endTime, userId: $userId, groupId: $groupId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeUserPlanStartEndTimeApiCall = async ({id, startTime, endTime, userId, groupId}, fragments = null) => apiCall({ query: CHANGEUSERPLANSTARTENDTIME_QUERY, variables: {id, startTime, endTime, userId, groupId}, fragments });
